<template lang="pug">
  v-btn(
    :color="routeState.myFollow ? undefined : `primary`"
    @click="$createOnClick({ onClick })"
    :text="!!routeState.myFollow") {{ routeState.myFollow ? `Se désabonner` : `S'abonner` }}
</template>

<script>
import data from '@iez/lib/data/'
import { injectRouteState } from '@iez/core'
import user from '@iez/lib/user/'
//import router from '@iez/core/router'
//import { page } from '@iez/core/'
//import waitFor from '@iez/lib/wait-for/'
//import { ref, computed } from '@vue/composition-api'
//import { page } from '@iez/core'
//import { ref } from '@vue/composition-api'

export default {
  name: `CallToAction1`,

  setup () {
    const routeState = injectRouteState()

    //const menu = ref(false)

    const onClick = () => {
      if (routeState.myFollow) {
        data.remove({
          root: 'followsUsers',
          ids: routeState.myFollow.id,
          parents: [{
            root: `users`,
            field: `followsUsersFollowers`,
            id: routeState.userId
          }]
        })
      } else {
        console.log('Following')
        data.set({
          root: 'followsUsers',
          fields: [
            'id'
          ],
          items: [{
            followerId: user.id,
            followedId: routeState.userId
          }]
        })  
        //router.back()
        //router.front()
        /*page.blockingDialog.set({
          title: `Essayez ultérieurement`,
          content: `Cette fonctionnalité n'est pas disponible pour le moment. Nous travaillons d'arrache-pied pour son arrivée prochaine`,
          action1: {
            label: `Fermer`,
            onClick: () => {
              page.blockingDialog.unset()
            }
          }
        })*/
        /*page.blockingMenu.set( 
          () => menu.value
            ? {
              title: `test`,
            } : null 
        )*/
        /*page.bottomSnackbar.set({
          content: `test`
        })*/
      }
    }

    return {
      onClick,
      routeState
    }
  }
}
</script>
